import { useModalControl } from '../../hooks/useModalControl'
import { EditInput } from '../inputs/editInput'
import { AddLocationModal } from '../modal/app_modals/addLocationModal'

export const VendorAddress = ({
  address,
  className,
  loading = false,
  onModify = () => {},
  error,
}: {
  address?: string
  className?: string
  loading?: boolean
  onModify?: (props: {
    data: {
      address: string
      latitude: number
      longitude: number
      placeId: string
    }
    close: () => void
  }) => void
  error?: string
}) => {
  const { setModalOpen, handleModalClose, handleModalOpen, modal, modalOpen } =
    useModalControl()

  return (
    <div>
      <EditInput
        title="Business Address"
        value={address}
        onEditClick={() => {
          handleModalOpen('selectAddressModal')
        }}
        errors={error}
        onCancel={() => {}}
        onEditSave={() => {}}
        editing={false}
        className={className}
      />

      <AddLocationModal
        open={modalOpen && modal === 'selectAddressModal'}
        setOpen={setModalOpen}
        onCloseCallback={() => {
          handleModalClose()
        }}
        onSuccessCallback={(val, reset) => {
          onModify({
            data: {
              address: val.address,
              latitude: Number(val.lat),
              longitude: Number(val.long),
              placeId: val.placeId,
            },
            close: () => {
              reset()
              handleModalClose()
            },
          })
        }}
        title="Creator Address"
        fields={['address', 'coordinates']}
        editOnSelect={false}
        schema={undefined}
        loading={loading}
      />
    </div>
  )
}
